export const changePanoramicStep = (payload) => {
  return {
    type: 'CHANGE_PANORAMIC_STEP',
    payload,
  };
};

export const setPanoramicPmSelected = (payload) => {
  return {
    type: 'SET_PANORAMIC_PM_SELECTED',
    payload,
  };
};

export const requestPanoramicPmReselect = () => {
  return {
    type: 'REQUEST_PANORAMIC_PM_RESELECT',
  };
};
